import { IApplicationState } from '../../types/redux';

export function getIsFlatViewOrderEnabled(state: IApplicationState) {
  return Boolean(state.newbuilding?.flatViewOrder?.isEnabled);
}
